/**
 * Import all module depenencies here.
 * Add commonly used modules to externals.
 */
import core from '../../app.core.module.js';
import memwordConfig from './memword.config.js';
import memwordRoute from './memword.route.js';
import memwordController from './memword.controller.js';
import memwordService from './memword.service.js';
import memwordDataService from './memword.data.service.js';

/**
 * This is the memword module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace memword Module
 */
angular.module('memword', [
  // Shared modules.
  core
])
// Register config.
.config(memwordConfig)
// Register route.
.config(memwordRoute)
// Register controller.
.controller('memwordController', memwordController)
// Register service.
.factory('memwordService', memwordService)
// Register data service.
.factory('memwordDataService', memwordDataService);

export default 'memword';


// WEBPACK FOOTER //
// ./src/login/memword/memword.module.js